import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { SITE } from "@/lib/site";

const links = [
  { label: "Home", href: "/#home" },
  { label: "Services", href: "/#services" },
  { label: "Attunements", href: "/#attunements" },
  { label: "Learn", href: "/#learn" },
  { label: "Shop", href: "/#shop" },
  { label: "About", href: "/#about" },
  { label: "Journal", href: "/blog" },
  { label: "Contact", href: "/#contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled ? "bg-[#FAF9F6]/85 backdrop-blur-md border-b border-[#EAE5D9]" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-12 flex h-20 items-center justify-between">
        <Link to="/" data-testid="nav-brand" className="flex items-center gap-3">
          <img
            src="https://customer-assets.emergentagent.com/job_aura-bliss-reiki/artifacts/uorreaw9_IMG_6294.jpg"
            alt="Aura Bliss Reiki"
            className="h-12 w-12 rounded-full object-cover ring-1 ring-[#EAE5D9]"
          />
          <div className="leading-tight">
            <div className="font-serif text-xl text-[#2C302E]">{SITE.brand}</div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-[#8A8D86]">by Archana Tiwari</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm tracking-wide text-[#2C302E] hover:text-[#B35B47] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/#contact"
            data-testid="nav-book-cta"
            className="rounded-full bg-[#2C302E] text-[#FAF9F6] text-sm px-5 py-2.5 hover:bg-[#B35B47] transition-colors"
          >
            Book a session
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          className="lg:hidden p-2 text-[#2C302E]"
          onClick={() => setOpen(!open)}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-[#FAF9F6] border-t border-[#EAE5D9]">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base text-[#2C302E]"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
